import { render, staticRenderFns } from "./SitePermitToWork.vue?vue&type=template&id=dceed460"
import script from "./SitePermitToWork.vue?vue&type=script&lang=js"
export * from "./SitePermitToWork.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports